import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { translate } from 'react-i18next'

import Sample404 from '../assets/img/sample/sample-404.png'

class NotFound extends Component {
  componentDidMount() {
    const { bodyClasses } = this.props

    bodyClasses.forEach(bodyClass => document.body.classList.add(bodyClass))
  }
  render() {
    const { t } = this.props

    return (
      <div className="page__wrapper">
        <div className="page__body">
          <div className="container">
            <p className="error-404__message">{ t('notfound.message') }</p>
            <div className="error-404__cta">
              <img src={Sample404} alt="Not Found" />
              <Link to={{pathname: '/', state: {to: 'home'}}} className="button button--round">{ t('notfound.button') }</Link>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default translate('common')(NotFound)



// WEBPACK FOOTER //
// ./src/pages/NotFound.js